package com.eladfinish.bible.contest.screens.completeVerse.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorPrimaryDark
import com.eladfinish.bible.contest.left_arrow
import com.eladfinish.bible.contest.new_verse
import com.eladfinish.bible.contest.right_arrow
import com.eladfinish.bible.contest.show_chapter
import dev.icerock.moko.resources.compose.colorResource
import dev.icerock.moko.resources.compose.stringResource

@Composable
internal fun NextVerseButton(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Button(
        onClick = onClick,
        modifier = modifier.padding(horizontal = 24.dp),
        colors = ButtonDefaults.buttonColors(
            containerColor = colorResource(SharedRes.colors.colorPrimaryDark),
        ),
    ) {
        Text(
            text = stringResource(SharedRes.strings.new_verse),
            fontSize = 22.sp,
        )
    }
}

/** Location of the completed verse (e.g. "(בראשית א, א)"); tapping it shows that chapter in a dialog. */
@Composable
internal fun VerseSourceLink(
    source: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Text(
        text = source,
        modifier = modifier
            .clickable(
                onClickLabel = stringResource(SharedRes.strings.show_chapter),
                role = Role.Button,
                onClick = onClick,
            )
            .padding(horizontal = 16.dp, vertical = 12.dp),
        color = colorResource(SharedRes.colors.colorPrimaryDark),
        fontSize = 20.sp,
        textAlign = TextAlign.Center,
        textDecoration = TextDecoration.Underline,
    )
}

@Composable
internal fun ArrowButtonsRow(
    onMoveLeft: () -> Unit,
    onMoveRight: () -> Unit,
    onMoveLeftLongPress: () -> Unit,
    onMoveRightLongPress: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(8.dp, Alignment.CenterHorizontally),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        ArrowButton(
            label = stringResource(SharedRes.strings.right_arrow),
            onClick = onMoveRight,
            onLongClick = onMoveRightLongPress,
        )
        ArrowButton(
            label = stringResource(SharedRes.strings.left_arrow),
            onClick = onMoveLeft,
            onLongClick = onMoveLeftLongPress,
        )
    }
}

@Composable
private fun ArrowButton(
    label: String,
    onClick: () -> Unit,
    onLongClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val color = colorResource(SharedRes.colors.colorPrimaryDark)
    Box(
        modifier = modifier
            .size(width = 72.dp, height = 48.dp)
            .pointerInput(Unit) {
                detectTapGestures(
                    onTap = { onClick() },
                    onLongPress = { onLongClick() },
                )
            }
            .drawBehind {
                drawRoundRect(
                    color = color,
                    cornerRadius = CornerRadius(12.dp.toPx()),
                )
            },
        contentAlignment = Alignment.Center,
    ) {
        Text(
            text = label,
            color = Color.White,
            fontSize = 22.sp,
            textAlign = TextAlign.Center,
        )
    }
}
